var map = {
	"./404": 9354,
	"./404.vue": 9354,
	"./Account": 7462,
	"./Account.vue": 7462,
	"./Finance": 2850,
	"./Finance.vue": 2850,
	"./Home": 7797,
	"./Home.vue": 7797,
	"./Login": 3104,
	"./Login.vue": 3104,
	"./Main": 4080,
	"./Main.vue": 4080,
	"./Mall": 9928,
	"./Mall.vue": 9928,
	"./Menu": 3579,
	"./Menu.vue": 3579,
	"./Role": 5748,
	"./Role.vue": 5748,
	"./SwitchSetting": 6107,
	"./SwitchSetting.vue": 6107,
	"./Upgrade": 8639,
	"./Upgrade.vue": 8639,
	"./User": 7155,
	"./User.vue": 7155,
	"./UserInfo": 7986,
	"./UserInfo.vue": 7986,
	"./WxPay": 9808,
	"./WxPay.vue": 9808,
	"./WxPayBefore": 2905,
	"./WxPayBefore.vue": 2905,
	"./equipment/EquipmentVideo": 8688,
	"./equipment/EquipmentVideo.vue": 8688,
	"./equipment/equipmentType": 7062,
	"./equipment/equipmentType.vue": 7062,
	"./equipment/operationStatus": 3319,
	"./equipment/operationStatus.vue": 3319,
	"./equipment/operationStatusRecord": 2567,
	"./equipment/operationStatusRecord.vue": 2567,
	"./flavorsList": 2155,
	"./flavorsList.vue": 2155,
	"./notification": 6246,
	"./notification.vue": 6246,
	"./pageConfig": 3217,
	"./pageConfig.vue": 3217,
	"./productList": 675,
	"./productList.vue": 675,
	"./productType": 4829,
	"./productType.vue": 4829,
	"./saleRecord": 6670,
	"./saleRecord.vue": 6670,
	"./system/BannerList": 229,
	"./system/BannerList.vue": 229,
	"./system/OpinionList": 3977,
	"./system/OpinionList.vue": 3977,
	"./system/SystemLog": 6708,
	"./system/SystemLog.vue": 6708,
	"./system/VideoList": 9195,
	"./system/VideoList.vue": 9195
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6968;
module.exports = webpackAsyncContext;